import { Spinner } from '@hqo/react-components-library/dist/atoms/spinner';
import {
  AppThemeProvider,
  defaultTheme,
  DefaultThemeWithFonts,
} from '@hqo/react-components-library/dist/molecules/theme';
import { ACTION_STATUSES } from 'shared/consts';

import { Container } from 'hocs/shared-styles';
import React from 'react';
import { useBuildingTheme } from 'hooks/use-building-theme.hook';
import { useSelector } from 'react-redux';
import { selectBuildingStatus } from 'store/building/selectors';
import { useBuilding } from 'hooks/use-building.hook';
import { CustomFonts } from 'components/custom-fonts';
import { AppContentWrapperStyles } from './app-content-wrapper.styles';
import { useViewParams } from 'hooks/use-view-params.hook';

interface AppContentWrapperProps {
  children: React.ReactNode;
}

export const AppContentWrapper = ({ children }: AppContentWrapperProps): JSX.Element => {
  const buildingStatus = useSelector(selectBuildingStatus);
  const params = useViewParams();
  const theme = useBuildingTheme();
  const building = useBuilding();
  const buildingStatusFinished =
    buildingStatus === ACTION_STATUSES.FULFILLED || buildingStatus === ACTION_STATUSES.REJECTED;

  const hasBuilding = building || params.buildingUuid;

  if (theme && (buildingStatusFinished || !hasBuilding)) {
    return (
      <>
        <AppContentWrapperStyles customThemeFonts={theme.fonts} />
        <CustomFonts />
        <AppThemeProvider theme={theme as DefaultThemeWithFonts}>{children}</AppThemeProvider>
      </>
    );
  }
  return (
    <Container data-testid="loading-container" isLoading>
      <Spinner size="10em" color={defaultTheme.colors.$greyLight} />
    </Container>
  );
};
